import React from "react";
import { useRouter } from "next/router";

const VirtualRoomInvite = ({
  urlParams,
  videoRoomSlug,
  isCorporateAgent,
  hostRoomUrl,
}) => {
  const router = useRouter();

  function handleRedirectToVideoroom() {
    const { eventSlug } = urlParams;

    if (isCorporateAgent) {
      router.push({
        pathname: `/agents/${urlParams.organizationSlug}/${urlParams.eventSlug}/videoroom/${videoRoomSlug}`,
        query: { hostRoomUrl: hostRoomUrl },
      });
    } else {
      router.push(`/${eventSlug}/${videoRoomSlug}`);
    }
  }

  return (
    <>
      {isCorporateAgent ? (
        <div className="corporate-virtual-room-invite p-2 mt-2">
          <span className="ms-2">
            {" "}
            <img src="/assets/videocallcorporate.svg" alt="" height="17" />
          </span>
          <p className="d-inline ms-3">Video room created!</p>
          <button
            className="btn d-block w-100"
            onClick={handleRedirectToVideoroom}
          >
            Join now
          </button>
        </div>
      ) : (
        <div className="virtual-room-invite p-2 mt-2">
          <span className="virtual-room-invite__icon ms-2">
            {" "}
            <img src="/assets/whiteVideoIcon.svg" alt="" height="17" />
          </span>
          <p className="virtual-room-invite__text d-inline ms-3">
            Video room created!
          </p>
          <button
            className="virtual-room-invite__button btn d-block w-100"
            onClick={handleRedirectToVideoroom}
          >
            Join now
          </button>
        </div>
      )}
    </>
  );
};

export default VirtualRoomInvite;
